// extracted by mini-css-extract-plugin
module.exports = {"mfaDeactivateImg":"mfaDeactivateModal_mfaDeactivateImg__H6r0y","btnDisabled":"mfaDeactivateModal_btnDisabled__2N0zQ"};